import { useQuery } from '@tanstack/react-query';
import ProjectInvitation, { ProjectInvitationJSON } from '@projectMembers/models/projectInvitation';
import useProjectMembersSystem from '../system/useProjectMembersSystem';
import { QueryKeys } from './keysAndFilters';
import { DEFAULT_QUERY_OPTIONS } from '../../projects/queries/constants';

const allProjectInvitationsFromJson = ( invitationsJson: ProjectInvitationJSON[] ) => (
	invitationsJson.map( ProjectInvitation.fromJson )
);

const useFetchProjectPendingInvitationsQuery = ( { projectID }: { projectID: number } ) => {
	const system = useProjectMembersSystem();

	return useQuery(
		QueryKeys.forProjectInvitations( { projectID } ),
		() => system.fetchProjectPendingInvites( { projectID } ),
		{
			...DEFAULT_QUERY_OPTIONS,
			select: allProjectInvitationsFromJson
		}
	);
};

export default useFetchProjectPendingInvitationsQuery;
